import classnames from "classnames";
import React, { Fragment } from "react";
import { Menu, MenuItem } from "react-bootstrap-typeahead";
import List from "react-tiny-virtual-list";

import "./dropDownMenu.scss";

type Props = {
    results: any;
    menuProps: any;
    listProps: any;
};

const DropDownMenu = ({ results, menuProps, listProps }: Props) => {
    const itemHeight = 40;
    const maxHeight = Math.min(300, results.length * itemHeight) + 4; // 4 = border radius bug on scrollbar in Windows

    return (
        <Menu
            {...menuProps}
            maxHeight={maxHeight}
            className="storePicker-autoComplete__dropdown-menu p-0"
        >
            <List
                scrollToIndex={
                    results.length > 0 ? listProps.activeIndex || 0 : undefined
                }
                // @ts-ignore
                scrollToAlignment={"auto"}
                height={maxHeight}
                itemCount={results.length || 0}
                itemSize={itemHeight}
                renderItem={({ index, style }) => {
                    if (results.length === 0) {
                        return <Fragment></Fragment>;
                    }
                    const item = results[index];
                    return (
                        <MenuItem
                            key={index}
                            option={item}
                            position={index}
                            style={style}
                            className={classnames(
                                "storePicker-autoComplete__dropdown-item",
                                {
                                    ["storePicker-autoComplete__dropdown-item--first"]:
                                        index === 0,
                                },
                            )}
                        >
                            {item.label}
                        </MenuItem>
                    );
                }}
            />
        </Menu>
    );
};

export default DropDownMenu;
